<section class="page-container">
    <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">Email Black List</h1>
      <app-navpath class="hidden md:block"></app-navpath>
    </div>
  
    <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" (click)="addEntry()">
        <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Email Black List
      </button>
      <button class="shorter-btn delete-btn" (click)="deleteSelectedEntries()">
        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>Delete
      </button>
      <app-search-input
        (dataOutput)="onSearch($event)"
        [isTable]="true"
        class="block w-full md:w-auto"
      ></app-search-input>
    </div>
  
    <div class="content-container">
      <div class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[28rem]"
          [tableHeaders]="tableHeaders"
          [tableEntries]="filteredEmails"
          (open)="openEntry($event)"
        ></app-data-table>
      </div>
    </div>
</section>
  
